import styled from 'styled-components';

import { TooltipText } from '@dreryk/react-components';

import { PriceText } from '../../../../shared/price/PriceText';

export const StyledPriceText = styled(PriceText)`
   color: ${({ theme }) => theme.textBody};
`;
StyledPriceText.displayName = 'StyledPriceText';

export const StyledTooltipText = styled(TooltipText)`
   display: grid;
`;
StyledTooltipText.displayName = 'StyledTooltipText';
